import { configureStore } from "@reduxjs/toolkit";
import { loaderReducers } from "./slices/MasterLoader";
import { messageApiReducers } from "./slices/messageApiSlice";
import { authReducers } from "./slices/authSlice";

const store = configureStore({
  reducer: {
    loader: loaderReducers,
    messageApi: messageApiReducers,
    auth: authReducers,
  },
});

export default store;
